// <s-reveal> fades and rises its children (or [data-reveal-item] descendants) into view once,
// the first time the element scrolls into the viewport. Content stays visible without JS
// or with reduced motion, because the hidden state only applies after [data-reveal-ready].
class SReveal extends HTMLElement {
  #observer;

  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    const explicit = this.querySelectorAll('[data-reveal-item]');
    const items = explicit.length ? Array.from(explicit) : Array.from(this.children);
    items.forEach((item, i) => {
      item.setAttribute('data-reveal-item', '');
      // Stagger caps at 8 items so long lists don't feel tedious.
      item.style.setProperty('--reveal-i', String(Math.min(i, 7)));
    });

    this.setAttribute('data-reveal-ready', '');
    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.setAttribute('data-revealed', '');
          this.#observer?.disconnect();
        }
      }
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-reveal')) customElements.define('s-reveal', SReveal);
